export const resolveLazyComponent = exportName => module => {
    const resolvedComponent = module[exportName];

    if (!resolvedComponent) {
        throw new Error(`Missed component while lazy loading ${exportName}`);
    }

    return { default: resolvedComponent };
};
